import React from 'react';
import footer1 from './assets/footer-1_new.png'
import footer2 from './assets/footer-2_new.png'
import climate from './assets/Climate_Logo_horizontal_RGB.png'
import lnob from './assets/LNOB_Logo_ENGL_HOR_RGB.png'
import { Link } from "react-router-dom";
import Logo from './assets/logo.png'

export default function Footer(props) {
    return <div className='footer pb-5' style={{ backgroundColor: "#fff" }}>
        <div className='row' style={{ borderBottom: "2px solid #000", padding: "10px 0" }}>
            <div className='col-sm-3'>
                <div style={{ maxWidth: 200 }}>
                    <img className='img-fluid' src={Logo} />
                </div>
            </div>
            <div className='col-sm-6'>
                <div className='d-flex justify-content-center'>
                    <div className='d-flex' >
                        <img className='footer-icon' src={footer1} />
                    </div>
                    <div className='d-flex align-items-center'>
                        <img className='footer-icon sdg' src={footer2}/>
                    </div>
                </div>
                <div className='d-flex justify-content-center mt-3'>
                    <div className='d-flex'>
                        <img className='footer-icon' src={climate} />
                    </div>
                    <div className='d-flex'>
                        <img className='footer-icon' src={lnob} />
                    </div>
                </div>
            </div>
            <div className='col-sm-3'>
                GHT is a <a href="https://teqbahn.com/social-impact" target='_blank'><b>Teqbahn</b></a> Collaboration with the Neurological Society of Kenya<br />
                Dr. Mahmood Qureshi, Chairman<br />
                P O Box 47603-00100, GPO, Nairobi, Kenya<br /><br />
                Teqbahn is registered as Teqbahn Foundation <br />
                A 501(c)(3) organization.  <br />
                Tax ID: 86-3034752 <br />
                email: <a href={"mailto:?subject=Teqbahn&body="}>vidyasri@teqbahn.com</a>
            </div>
        </div>
        <div className='text-center mt-3'>
            © {new Date().getFullYear()} by Teqbahn. All Rights Reserved. | <Link to={"/privacy-policy-ght"}>Privacy Policy</Link>
        </div>
    </div>;
}
